// extracted by mini-css-extract-plugin
export default {"PFSHomepage":"PFSHomepage_PFSHomepage__bxBjq"};